<div class="card-container box-shadow">
  <!-- Info Text -->
  <div class="info-text">
    <app-info-card>
      <ng-container *ngTemplateOutlet="infoText"></ng-container>
    </app-info-card>
  </div>

  <div style="display: flex">
    <!-- Main Checkbox -->
    <app-checkbox
      [checkBoxControl]="checkboxFormControl"
      [isDisabled]="checkboxDisabled"
      [dataCy]="title"
    ></app-checkbox>
  </div>

  <p class="title">{{ title }}</p>
  <p class="subtitle">{{ subtitle }}</p>
  <p class="text">{{ text }}</p>
</div>
